import { DOMAIN } from '../constants';

export const clsPrefix = 'cap-genie-bot';

export const ASK_AIRA_ANALYTICS = `${DOMAIN}/arya/api/v1/ask-aira-service/proxy/ai-analytics-service`;

export const SEND_PROMPT_REQUEST = 'SEND_PROMPT_REQUEST';
export const SEND_PROMPT_SUCCESS = 'SEND_PROMPT_SUCCESS';
export const SEND_PROMPT_FAILURE = 'SEND_PROMPT_FAILURE';

export const MODIFY_SQL_REQUEST = 'MODIFY_SQL_REQUEST';
export const MODIFY_SQL_SUCCESS = 'MODIFY_SQL_SUCCESS';
export const MODIFY_SQL_FAILURE = 'MODIFY_SQL_FAILURE';

export const CLEAR_SESSION_REQUEST = 'CLEAR_SESSION_REQUEST';
export const CLEAR_SESSION_SUCCESS = 'CLEAR_SESSION_SUCCESS';
export const CLEAR_SESSION_FAILURE = 'CLEAR_SESSION_FAILURE';

export const INIT_SESSION_REQUEST = 'INIT_SESSION_REQUEST';
export const INIT_SESSION_SUCCESS = 'INIT_SESSION_SUCCESS';
export const INIT_SESSION_FAILURE = 'INIT_SESSION_FAILURE';

export const GET_SUGGESTION_REQUEST = 'GET_SUGGESTION_REQUEST';
export const GET_SUGGESTION_SUCCESS = 'GET_SUGGESTION_SUCCESS';
export const GET_SUGGESTION_FAILURE = 'GET_SUGGESTION_FAILURE';

export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';
export const RESET_GENIE = 'RESET_GENIE';

export const UPVOTE_QUERY_REQUEST = 'UPVOTE_QUERY_REQUEST';
export const UPVOTE_QUERY_SUCCESS = 'UPVOTE_QUERY_SUCCESS';
export const UPVOTE_QUERY_FAILURE = 'UPVOTE_QUERY_FAILURE';
export const SET_FETCH_STATUS = 'SET_FETCH_STATUS';
export const CANCEL_PROMPT = 'CANCEL_PROMPT';
export const SEND_LOG_REQUEST = 'SEND_LOG_REQUEST';
export const SEND_LOG_SUCCESS = 'SEND_LOG_SUCCESS';
export const SEND_LOG_FAILURE = 'SEND_LOG_FAILURE';

export const baseReqObject = {
  prompt: '',
  org_id: 0,
  query: '',
  interpretation: '',
  response: {},
  piData: '',
};

export const GENIE_REDUCER_DOMAIN = 'GENIE';
